import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faDollarSign, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faDollarSign, faQuestionCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)
